import(/* webpackMode: "eager" */ "C:\\Users\\62877\\Documents\\NAYVERA\\src\\app\\kontak-page\\page.tsx");
